// @ts-nocheck
import { useTransportGroupData } from "components/Common/GroupTransportSelect";
import { ORDER_TYPE, SHIPPING_TYPE } from "constants/order";
import moment from "moment";
import { getLableOrderStatus } from "pages/Orders/utils";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledAccordion,
} from "reactstrap";
import { useSales } from "../../../../hooks";
import "../OrderDetailForm/OrderDetailForm.scss";

const OrderDetailForm = props => {
  const { t } = useTranslation(["order"]);

  const {
    orderScanInfo,
    data: order,
    wards,
    districts,
    provinces,
    isHCMOrder,
    shippingUnitType,
    shipping,
    orderStatusList,
    runner,
    customer,
    isHighlightCustomerName,
  } = props;

  const [isOpenMoreInfo, setIsOpenMoreInfo] = useState(false);
  const [orderDetail, setOrderDetail] = useState(null);
  const [saleName, setSaleName] = useState(null);
  const { data: lsSales, refetch: refetchSales } = useSales({
    customerId: order?.customer_id,
  });
  const { getGroupTransportOption, optionsSelect } = useTransportGroupData();

  const isAddressLevel2 = useMemo(() => {
    return orderDetail?.is_new_address === "N";
  }, [orderDetail?.is_new_address]);

  const orderStatusLabel = useMemo(() => {
    return getLableOrderStatus(orderStatusList, orderDetail?.status);
  }, [orderStatusList, orderDetail]);

  useEffect(() => {
    if (order?.customer_id) {
      refetchSales(order?.customer_id);
    }
  }, [order?.customer_id]);

  useEffect(() => {
    if (!!order) {
      let inforCustomer = {
        customer_full_address: "",
        customer_address: "",
        customer_ward_code: "",
        customer_district_code: "",
        customer_province_code: "",
        customer_contact_name: "",
        customer_contact_phone: "",
      };
      switch (order?.type) {
        case 1:
          inforCustomer = {
            customer_full_address: order?.reciever_full_address,
            customer_address: order?.reciever_address,
            customer_ward_code: order?.reciever_ward_code,
            customer_district_code: order?.reciever_district_code,
            customer_province_code: order?.reciever_province_code,
            customer_contact_name: order?.reciever_contact_name,
            customer_contact_phone: order?.reciever_contact_phone,
          };
          break;
        case 2:
          inforCustomer = {
            customer_full_address: order?.sender_full_address,
            customer_address: order?.sender_address,
            customer_ward_code: order?.sender_ward_code,
            customer_district_code: order?.sender_district_code,
            customer_province_code: order?.sender_province_code,
            customer_contact_name: order?.sender_contact_name,
            customer_contact_phone: order?.sender_contact_phone,
          };
          break;
        case 3:
          inforCustomer = {
            customer_full_address: order?.sender_full_address,
            customer_address: order?.sender_address,
            customer_ward_code: order?.sender_ward_code,
            customer_district_code: order?.sender_district_code,
            customer_province_code: order?.sender_province_code,
            customer_contact_name: order?.sender_contact_name,
            customer_contact_phone: order?.sender_contact_phone,
          };
          break;
        default:
      }
      const data = {
        ...order,
        ...inforCustomer,
      };
      setIsOpenMoreInfo(data?.is_receive_bus === 1 ? false : true);
      setOrderDetail(data);
      setSaleName(order?.sale_name);
    }
  }, [order]);

  const busNameDisplay = useMemo(() => {
    if (orderDetail?.orderDelivery?.shipping_type === SHIPPING_TYPE.DVVC) {
      return getGroupTransportOption(
        orderDetail?.transport_group_code,
        optionsSelect
      )?.label;
    }

    return orderDetail?.transport_name || t("form.no_information");
  }, [orderDetail, optionsSelect]);

  return (
    <Form className="OrderDetailForm">
      <Row xs={1} md={4}>
        <Col>
          <FormGroup
            className={`gy-2 ${isHighlightCustomerName ? "hight-light" : ""} `}
          >
            <Label htmlFor="customers">{t("detail.customerName")}</Label>
            <Input
              id="customers"
              type="text"
              value={orderScanInfo?.customer_name || customer?.name || ""}
              readOnly
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="gy-2">
            <Label htmlFor="sale_id">{t("detail.sale_id")}</Label>
            <Input
              id="customers"
              type="text"
              value={orderScanInfo?.sale_name || saleName || ""}
              readOnly
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="state-order">{t("detail.stateOrder")}</Label>
            <Input
              id="state-order"
              type="text"
              value={orderStatusLabel}
              readOnly
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="last_update">{t("detail.lastUpdate")}</Label>
            <Input
              type="text"
              id="last_update"
              value={
                orderDetail?.checker_date
                  ? moment(new Date(orderDetail?.checker_date * 1000)).format(
                      "DD/MM/YYYY HH:mm:ss"
                    )
                  : t("form.no_information")
              }
              readOnly
            />
          </FormGroup>
        </Col>
      </Row>
      <UncontrolledAccordion
        key={isOpenMoreInfo}
        defaultOpen={isOpenMoreInfo ? "1" : ""}
      >
        <AccordionItem>
          <AccordionHeader targetId="1">
            <div className="d-flex gap-1 align-items-center fw-bold font-size-14">
              <i className="fa fa-info-circle" aria-hidden="true"></i>Thông tin
              thêm
            </div>
          </AccordionHeader>
          <AccordionBody accordionId="1">
            <Row xs={1} md={2}>
              <Col>
                <FormGroup>
                  <Label htmlFor="position-pick-order">
                    {t("detail.positionPickOrder")}
                  </Label>
                  <Input
                    id="position-pick-order"
                    type="text"
                    value={orderDetail?.customer_full_address || ""}
                    readOnly
                  />
                </FormGroup>
                <Row xs={1} md={2}>
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="addressOrder"
                        className="visually-hidden"
                      />
                      <Input
                        id="addressOrder"
                        type="text"
                        value={orderDetail?.customer_address || ""}
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                  {!isAddressLevel2 && (
                    <Col>
                      <FormGroup>
                        <Label
                          htmlFor="wardOrder"
                          className="visually-hidden"
                        />
                        <Input
                          type="text"
                          id="wardOrder"
                          value={wards?.[orderDetail?.customer_ward_code] || ""}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                  )}
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="districtOrder"
                        className="visually-hidden"
                      />
                      <Input
                        type="text"
                        id="districtOrder"
                        value={
                          districts?.[orderDetail?.customer_district_code] || ""
                        }
                        readOnly
                      />
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup>
                      <Label htmlFor="cityOrder" className="visually-hidden" />
                      <Input
                        type="text"
                        id="cityOrder"
                        value={
                          provinces?.[orderDetail?.customer_province_code] || ""
                        }
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="customer-name"
                        className="visually-hidden"
                      />
                      <Input
                        type="text"
                        id="customer-name"
                        value={orderDetail?.customer_contact_name || ""}
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup>
                      <Label
                        htmlFor="customer-phone-number"
                        className="visually-hidden"
                      />
                      <Input
                        type="text"
                        id="customer-phone-number"
                        value={orderDetail?.customer_contact_phone || ""}
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup>
                  <Label htmlFor="collection-time">
                    {t("detail.collectionTime")}
                  </Label>
                  <Row xs={1} md={2}>
                    <Col>
                      <FormGroup
                        className="d-flex align-items-center border-1"
                        style={{ backgroundColor: "#f4f5f4" }}
                      >
                        <span
                          style={{ paddingLeft: "12px" }}
                          className="prefix"
                        >
                          {t("detail.dateLabel")}
                        </span>
                        <Input
                          id="collection-time"
                          name="date"
                          type="text"
                          readOnly
                          value={
                            orderDetail?.action_date
                              ? moment(orderDetail?.action_date).format(
                                  "DD/MM/YYYY"
                                )
                              : ""
                          }
                          className="pl-4"
                          style={{ paddingLeft: "3px" }}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label
                          htmlFor="collection-hour"
                          className="visually-hidden"
                        />
                        <Input
                          id="collection-hour"
                          className="basic-single"
                          value={orderDetail?.time_slot_name || ""}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    {isHCMOrder && (
                      <>
                        {" "}
                        <Col>
                          <FormGroup
                            className="orders-card d-flex align-items-center"
                            style={{ padding: "12px" }}
                          >
                            <Input
                              name="get-money"
                              type="checkbox"
                              className="mt-0"
                              checked={orderDetail?.collect_money || false}
                              readOnly
                            />
                            <Label
                              check
                              htmlFor="get-money"
                              style={{
                                marginLeft: "8px",
                                fontWeight: "400",
                              }}
                            >
                              {t("detail.getMoney")}
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup
                            className="orders-card d-flex align-items-center"
                            style={{ padding: "12px" }}
                          >
                            <Input
                              name="book-grab"
                              type="checkbox"
                              className="mt-0"
                              checked={orderDetail?.is_grab || false}
                              readOnly
                            />
                            <Label
                              check
                              htmlFor="book-grab"
                              style={{
                                marginLeft: "8px",
                                fontWeight: "400",
                              }}
                            >
                              {t("detail.bookGrab")}
                            </Label>
                          </FormGroup>
                        </Col>
                      </>
                    )}
                  </Row>
                  {isHCMOrder === false && (
                    <>
                      <Label htmlFor="shipping_type">
                        {t("form.shipping_type")}{" "}
                      </Label>
                      <Row xs={1} md={2}>
                        {orderDetail?.type !== ORDER_TYPE.COLLECTOR.value && (
                          <Col>
                            <FormGroup>
                              <Label
                                htmlFor="shipping_type"
                                className="visually-hidden"
                              >
                                {t("form.shipping_type")}{" "}
                                <span className="text-danger">*</span>
                              </Label>
                              <Input
                                type="text"
                                placeholder={t("placeholder.select", {
                                  title: t("form.shipping_type"),
                                })}
                                value={
                                  shippingUnitType?.[
                                    orderDetail?.orderDelivery?.shipping_type
                                  ] || ""
                                }
                                readOnly
                              />
                            </FormGroup>
                          </Col>
                        )}

                        <Col>
                          <FormGroup>
                            <Label
                              htmlFor="bus_id"
                              className="visually-hidden"
                            />
                            <Input
                              type="text"
                              placeholder={t("placeholder.select", {
                                title: t("form.bus_id"),
                              })}
                              value={busNameDisplay}
                              readOnly
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </>
                  )}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="note">{t("detail.note.title")}</Label>
                  <Input
                    type="textarea"
                    id="note"
                    rows={9}
                    style={{ lineHeight: "19px" }}
                    value={`${order?.mainNote || order?.note || ""}`}
                    readOnly
                  ></Input>
                </FormGroup>
                <FormGroup>
                  <Label htmlFor="transport-unit">
                    {isHCMOrder
                      ? t("detail.transportUnit")
                      : t("form.order_state")}
                  </Label>
                  <Row xs={1} md={2}>
                    {isHCMOrder && (
                      <>
                        <Col>
                          <FormGroup>
                            <Input
                              id="shipping_type"
                              className="basic-single"
                              readOnly
                              value={
                                shippingUnitType?.[
                                  orderDetail?.orderDelivery?.shipping_type
                                ] || ""
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup>
                            <Label
                              htmlFor="name-transport-unit"
                              className="visually-hidden"
                            />
                            <Input
                              name="shipping_type"
                              readOnly
                              value={busNameDisplay}
                            />
                          </FormGroup>
                        </Col>
                      </>
                    )}
                    <Col>
                      <FormGroup>
                        <Label
                          htmlFor="get-order-time"
                          className="visually-hidden"
                        />
                        <Input
                          type="text"
                          id="get-order-time"
                          value={`${t("detail.receiverOrder")}: ${
                            orderDetail?.orderDelivery?.recieve_time
                              ? moment(
                                  orderDetail?.orderDelivery?.recieve_time
                                ).format("DD/MM/YYYY HH:mm:ss")
                              : t("form.no_information")
                          }`}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label
                          htmlFor="deliver-order-time"
                          className="visually-hidden"
                        />
                        <Input
                          type="text"
                          id="deliver-order-time"
                          value={`${t("detail.senderOrder")}: ${
                            orderDetail?.orderDelivery?.delivery_time
                              ? moment(
                                  orderDetail?.orderDelivery?.delivery_time
                                ).format("DD/MM/YYYY HH:mm:ss")
                              : t("form.no_information")
                          }`}
                          readOnly
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
          </AccordionBody>
        </AccordionItem>
      </UncontrolledAccordion>
    </Form>
  );
};

OrderDetailForm.propTypes = {
  orderScanInfo: PropTypes.object,
  orderStatusList: PropTypes.array,
  wards: PropTypes.object,
  districts: PropTypes.object,
  provinces: PropTypes.object,
  data: PropTypes.object,
  shippingUnitType: PropTypes.object,
  customer: PropTypes.object,
  runner: PropTypes.object,
  isHCMOrder: PropTypes.bool,
  shipping: PropTypes.object,
  isHighlightCustomerName: PropTypes.bool,
};
export default OrderDetailForm;
